import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

export const BreadcrumbsContainer = styled('div', {
  variants: {
    showBreadcrumbAtMediumScreenSize: {
      true: {
        '@media (max-width: 464px)': {
          display: 'none',
        },
      },
      false: {
        '@media (max-width: 984px)': {
          display: 'none',
        },
      },
    },
    showBreadcrumbAtSmallScreenSize: {
      true: {
        '@media (min-width: 465px)': {
          display: 'none',
        },
        '@media (max-width: 464px)': {
          display: 'block',
        },
      },
    },
  },
  '.abyss-breadcrumbs-root': {
    backgroundColor: '$core.color.brand.100',
    flexWrap: 'no-wrap',
    paddingBottom: '$sm',
    color: '$core.color.neutral.0',
  },
  '.abyss-breadcrumb-link': {
    color: '$core.color.neutral.0',
    fontWeight: '500',
  },
  '.abyss-breadcrumb-current': {
    color: '$core.color.neutral.0',
  },
});

export const BreadcrumbsSpacing = styled('div', {
  '@media (max-width: 464px)': {
    backgroundColor: '$core.color.brand.100',
    height: '16px',
  },
  '@media (min-width: 465px)': {
    display: 'none',
  },
});

export const HeaderIcon = styled(IconSymbol, {
  '&.abyss-icon-symbol': {
    marginRight: '12px',
    minWidth: '24px',
    minHeight: '24px',
  },
});

export const BackButton = styled(Button, {
  variants: {
    showBreadcrumbAtMediumScreenSize: {
      true: {
        '@media (min-width: 464px)': {
          display: 'none',
        },
      },
      false: {
        '@media (min-width: 985px)': {
          display: 'none',
        },
      },
    },
    showBreadcrumbAtSmallScreenSize: {
      true: {
        '@media (max-width: 464px)': {
          display: 'none',
        },
      },
    },
  },
  '&.abyss-button-root': {
    height: 'unset',
    border: 'none',
    padding: '0',
    lineHeight: '$sm',
  },
});
